export default function keepOnlyNumbers(str) {
  let result =  str + "".replace(/\D/g, "");
  return result;
}
